/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-27 11:30:29
 * @LastEditors: game.pluto.com 66291979@qq.com
 * @LastEditTime: 2024-07-04 16:02:43
 * @FilePath: \lobby\src\main.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import './assets/styles/main.scss'
import './common/flexible.js'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { MGTag } from '@/common/mgtag.js'
import { VantResolve } from '@/common/vant.js'
import eventBus from '@/event/EventBus.js'
import App from './App.vue'
import { i18n } from './locales'
import router from './router'

// if ('serviceWorker' in navigator) {
//   // 获取动态生成的文件名
//   fetch('/sw-manifest.json')
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error('Failed to load sw-manifest.json')
//       }
//       return response.json()
//     })
//     .then((manifest) => {
//       const swFileName = manifest.swFileName
//       if (!swFileName) {
//         throw new Error('Service Worker file name not found in manifest.')
//       }

//       // 注册 Service Worker
//       navigator.serviceWorker
//         .register(`/${swFileName}`)
//         .then((registration) => {
//           console.log('Service Worker registered with scope:', registration.scope)
//         })
//         .catch((error) => {
//           console.error('Service Worker registration failed:', error)
//         })
//     })
//     .catch((error) => {
//       console.error('Failed to fetch Service Worker manifest:', error)
//     })
// }

if (__APP_ENV__ == 'app_staging') {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole({ theme: 'dark' })
  })
} else if (__APP_ENV__ !== 'app') {
  window.addEventListener('beforeinstallprompt', (event) => {
    // 阻止默认的安装提示
    event.preventDefault()
    // 保存事件以便稍后触发
    window.deferredPrompt = event
    // 显示安装按钮
    // document.getElementById('installPWA')?.classList.remove('hidden')
  })
  window.addEventListener('appinstalled', () => {
    console.log('PWA 已安装')
    // alert('感谢您安装本应用！')
  })
}

let lastTouchEnd = 0

document.addEventListener(
  'touchend',
  (event) => {
    const now = new Date().getTime()
    if (now - lastTouchEnd <= 300) {
      event.preventDefault()
    }
    lastTouchEnd = now
  },
  false
)

const app = createApp(App)
app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(VantResolve)
app.use(MGTag, router)
// app.use(updateSW)
eventBus(app)

app.mount('#app')
